// Catálogo de "ganchos" (hooks) — clips de video vertical que se antepondrán
// al video generado del modo "Video con influencer".
//
// SCAFFOLD: la tabla de ganchos todavía NO existe. Por ahora exportamos una
// lista vacía y el `GanchoPicker` renderiza slots placeholder (espacio
// reservado) para que se vea la UI. Cuando exista la tabla, este módulo se
// reemplaza por un fetch a Supabase que devuelva `GanchoOption[]` con el
// `nombre` real y el `videoUrl` del clip vertical.

export interface GanchoOption {
  /** Id del gancho (futuro: PK de la tabla `ganchos`). */
  id: string;
  /** Nombre visible del gancho (futuro: columna `nombre`). */
  nombre: string;
  /** URL del clip vertical (9:16). Opcional mientras no existan assets. */
  videoUrl?: string;
  /** Poster/thumbnail del clip. Opcional. */
  posterUrl?: string;
}

/**
 * Ganchos disponibles. Vacío por ahora (la tabla no existe). El picker cae
 * a placeholders cuando esta lista está vacía.
 */
export const GANCHOS: GanchoOption[] = [];

/**
 * Cantidad de slots placeholder (9:16) que muestra el picker mientras no
 * haya ganchos cargados — solo para reservar/visualizar el espacio.
 */
export const GANCHO_PLACEHOLDER_SLOTS = 4;
